import React, { useState } from 'react';
import './HelpCenter.css';
import GettingStarted from './GettingStarted';
import ZwalletGuide from './ZwalletGuide';
import ENSGuide from './ENSGuide';
import TechnicalManual from './TechnicalManual';
import Troubleshooting from './Troubleshooting';

const HelpCenter = ({ embedded = false, skipAuth = false }) => {
  const [activeTab, setActiveTab] = useState('getting-started');

  const tabs = [
    { id: 'getting-started', label: '🚀 Getting Started', component: <GettingStarted /> },
    { id: 'zwallet-guide', label: '🏦 Zwallet Guide', component: <ZwalletGuide /> },
    { id: 'ens-guide', label: '🎯 ENS Guide', component: <ENSGuide /> },
    { id: 'technical', label: '🏗️ Technical', component: <TechnicalManual /> },
    { id: 'troubleshooting', label: '🐛 Troubleshooting', component: <Troubleshooting /> }
  ];

  return (
    <div className={`help-center-wrapper ${embedded ? 'embedded-mode' : ''}`}>
      {/* Conditionally show header if not embedded */}
      {!embedded && (
        <div className="help-center-header">
          <h2 className="gold-text">📚 Zpost Help Center</h2>
          <p className="text-secondary">
            Complete documentation for Zpost Social, Zwallet, ENS Suite, Zhat, and Zearch
          </p>
        </div>
      )}

      {/* Tabs Navigation */}
      <div className="help-center-tabs">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Search Bar */}
      <div className="help-center-search">
        <input 
          type="text" 
          placeholder="Search help articles..." 
          className="search-input"
        />
        <button className="btn btn-gold search-button">
          <i className="fas fa-search"></i> Search
        </button>
      </div>

      {/* Active Tab Content */}
      <div className="help-center-content">
        {tabs.find(tab => tab.id === activeTab)?.component}
      </div>

      {/* Footer */}
      {!embedded && (
        <div className="help-center-footer">
          <p className="text-secondary">
            Need more help? Visit <a href="https://zpost.ai" target="_blank" rel="noopener noreferrer">zpost.ai</a> 
            or join the .zpost.eth community
          </p>
        </div>
      )}
    </div>
  );
};

export default HelpCenter;
